class RecipientFormV2 extends HTMLElement {
  connectedCallback() {
    this.labelCheckbox = this.querySelector(".recipient-checkbox");
    this.labelCheckbox.addEventListener("click", () => {
      this.clearFields();
    });

    this.messageEl = this.querySelector('[name="properties[Message]"]');
    this.charCount = this.querySelector("[data-char-count]");
    if (this.messageEl && this.charCount) {
      this.messageEl.addEventListener("input", () => {
        this.charCount.textContent = this.messageEl.value.length + "/200";
      });
    }
  }

  clearFields() {
    this.nameEl = this.querySelector('[name="properties[Recipient name]"]');
    this.emailEl = this.querySelector('[name="properties[Recipient email]"]');
    this.messageEl = this.querySelector('[name="properties[Message]"]');
    this.SendOnEl = this.querySelector('[name="properties[Send on]"]');
    this.labelError = this.querySelector(".email-error-message");
    this.labelError && this.labelError.classList.add("hidden");

    this.nameEl && (this.nameEl.value = "");
    this.emailEl && (this.emailEl.value = "");
    this.messageEl && (this.messageEl.value = "");
    this.SendOnEl && (this.SendOnEl.value = "");
    if (this.charCount) this.charCount.textContent = "0/200";
  }

  propertiesValues() {
    this.checkbox = this.querySelector("#recipient-checkbox-v2");

    if (!this.checkbox || !this.checkbox.checked) {
      this.emailValue = "";
      return {};
    }

    this.nameEl = this.querySelector('[name="properties[Recipient name]"]');
    this.emailEl = this.querySelector('[name="properties[Recipient email]"]');
    this.messageEl = this.querySelector('[name="properties[Message]"]');
    this.SendOnEl = this.querySelector('[name="properties[Send on]"]');

    this.nameValue = this.nameEl ? this.nameEl.value : "";
    this.emailValue = this.emailEl ? this.emailEl.value : "";
    this.messageValue = this.messageEl ? this.messageEl.value : "";
    this.SendOnValue = this.SendOnEl ? this.SendOnEl.value : "";

    return {
      "Recipient name": this.nameValue,
      "Recipient email": this.emailValue,
      Message: this.messageValue,
      "Send on": this.SendOnValue,
      __shopify_send_gift_card_to_recipient: "if_present",
      __shopify_offset: new Date().getTimezoneOffset().toString(),
    };
  }

  validProperties() {
    this.checkbox = this.querySelector("#recipient-checkbox-v2");

    if (this.checkbox && !this.checkbox.checked) {
      return true;
    }
    const isValidEmail = this.validateEmail(this.emailValue);
    return isValidEmail;
  }

  validateEmail(email = "") {
    this.labelError = this.querySelector(".email-error-message");
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValid = regex.test(email);

    if (isValid) {
      this.labelError.classList.add("hidden");
    } else {
      this.labelError.classList.remove("hidden");
    }
    return isValid;
  }
}

customElements.define("recipient-form-v2", RecipientFormV2);
